module.exports = __webpack_public_path__ + "img/Oman.21a2e047.svg";